export type PeriodType = 'hours' | 'days'

export const MAX_LOOKAHEAD_DAYS = 14
export const MAX_LOOKAHEAD_HOURS = MAX_LOOKAHEAD_DAYS * 24

export const PERIOD_OPTIONS: Record<PeriodType, { id: PeriodType; label: string; max: number }> = {
  hours: { id: 'hours', label: 'hours', max: MAX_LOOKAHEAD_HOURS },
  days: { id: 'days', label: 'days', max: MAX_LOOKAHEAD_DAYS },
}

export const getPeriodType = (lookaheadHours: number): PeriodType => {
  return lookaheadHours < 24 || lookaheadHours % 24 !== 0 ? 'hours' : 'days'
}

export const getPeriodValue = (lookaheadHours: number): number => {
  return getPeriodType(lookaheadHours) === 'hours' ? lookaheadHours : lookaheadHours / 24
}

export const normalizePeriodValue = (value: number, periodType: PeriodType): number => {
  if (Number.isNaN(value)) {
    return 1
  }
  return Math.max(1, Math.min(Math.round(value), PERIOD_OPTIONS[periodType].max))
}
